import HeroButton from "@components/HeroButton";

import Image from "next/image";
import React from "react";

interface integrationHeaderProps {
    title: string;

    description: string;
    imageUrl?: string;
}

const IntegrationHeader: React.FC<integrationHeaderProps> = (props) => {
    const { title, description, imageUrl } = props;
    const defaultImageUrl = "https://assets.gallabox.com/gb-home/shopify-landing/header.png";
    return (
        <header className="max-w-6xl mx-auto px-4 lg:px-0 pt-4  bg-white ">
            <div className="flex flex-col lg:flex-row justify-center md:justify-between lg:py-28 pt-0">
                <div className="lg:w-1/2 w-full flex flex-col">
                    <h1 className="text-gray-600 md:text-4xl text-2xl text-center mt-10 md:mt-5 md:text-left">{title}</h1>
                    <p className="lg:py-10 py-4 lg:text-xl font-normal text-center lg:text-left text-gray-500 ">{description}</p>
                    <HeroButton />
                    <div className="flex gap-4 px-2 lg:px-0 mt-6">
                        {["No setup fee", "No credit card required"].map((each) => {
                            return (
                                <div className="flex items-center gap-1 md:gap-2" key={each}>
                                    <img src="https://assets.gallabox.com/gb-home/content-with-image/grey-tick-circle.svg" alt="Gray checkmark" className="opacity-50" />
                                    <p className=" text-gray-400 text-base font-sans font-normal">{each}</p>
                                </div>
                            );
                        })}
                    </div>
                </div>
                <div className="lg:w-1/2 w-full lg:pt-0 pt-4 ">
                    <Image src={imageUrl || defaultImageUrl} width={585} height={480} alt="integration-pillar" />
                </div>
            </div>
        </header>
    );
};

export default IntegrationHeader;
